export default "__VITE_ASSET__TY1TOfHB__"